import _classCallCheck from "C:\\Users\\Nehal\\Documents\\Projects\\230605LC_Fravo\\Fravo\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Nehal\\Documents\\Projects\\230605LC_Fravo\\Fravo\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { setRangeValue } from "../../../../Utils/NumberUtils";
export var Attract = /*#__PURE__*/function () {
  function Attract() {
    _classCallCheck(this, Attract);
    this.distance = 200;
    this.enable = false;
    this.rotate = {
      x: 3000,
      y: 3000
    };
  }
  _createClass(Attract, [{
    key: "rotateX",
    get: function get() {
      return this.rotate.x;
    },
    set: function set(value) {
      this.rotate.x = value;
    }
  }, {
    key: "rotateY",
    get: function get() {
      return this.rotate.y;
    },
    set: function set(value) {
      this.rotate.y = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _a, _b, _c, _d;
      if (!data) {
        return;
      }
      if (data.distance !== undefined) {
        this.distance = setRangeValue(data.distance);
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      var rotateX = (_b = (_a = data.rotate) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : data.rotateX;
      if (rotateX !== undefined) {
        this.rotate.x = rotateX;
      }
      var rotateY = (_d = (_c = data.rotate) === null || _c === void 0 ? void 0 : _c.y) !== null && _d !== void 0 ? _d : data.rotateY;
      if (rotateY !== undefined) {
        this.rotate.y = rotateY;
      }
    }
  }]);
  return Attract;
}();